<template>
  <div fixed grow class="pa-0 ma-0" dense>
    <div v-if="canTransfer" class="btn-group">
      <button
        @click="$emit('on-transfer', -1)"
        class="btn btn-xs btn-outline-danger"
        v-if="transferOptions.canReturnTask"
      >
        <b-icon icon="arrow-left" class="pd-t-5"></b-icon>
        <span class="text-uppercase">Буцаах</span>
      </button>
      <button
        @click="$emit('on-transfer', 1)"
        class="btn btn-xs btn-outline-primary"
      >
        <span class="mg-r-5 text-uppercase">
          Шилжүүлэх
          <template v-if="transferOptions.skipAfterColumn.id > 0"
            >({{ transferOptions.skipAfterColumn.name }})</template
          >
        </span>
        <b-icon icon="arrow-right" class="pd-t-5"></b-icon>
      </button>
      <button
        @click="$emit('on-transfer', 2)"
        class="btn btn-xs btn-outline-success"
        v-if="transferOptions.canFinishTask"
      >
        <b-icon icon="check2-all" class="pd-t-5"></b-icon>
        <span class="white--text">Дуусгах</span>
      </button>
    </div>
    <button
      @click="$emit('on-transfer', 22)"
      class="btn btn-xs btn-outline-primary"
      v-else-if="canFinish"
    >
      <b-icon icon="check2-all" class="pd-t-5"></b-icon>
      <span class="white--text">Дуусгах &#38; Дүн боловсруулах</span>
    </button>
    <button
      @click="$emit('on-transfer', 222)"
      class="btn btn-xs btn-outline-warning"
      v-else-if="canOpen"
    >
      <b-icon icon="unlock" class="pd-t-5"></b-icon>
      <span class="white--text">Нээх ?</span>
    </button>
    <div
      v-else-if="task.isCompleted"
      class="mg-t-20 alert alert-success"
      role="alert"
    >
      Дуусгасан ({{ task.completedAt | moment("YYYY.MM.DD HH:mm") }})
    </div>
    <div
      v-else-if="task.column != null"
      class="mg-t-20 alert alert-warning"
      role="alert"
    >
      {{ msg }}
    </div>
    <button
      @click="$emit('on-transfer', 888)"
      type="button"
      class="btn btn-xs btn-warning mg-l-20"
      v-if="
        (task.objectTypeId == 465 ||
          task.objectTypeId == 467 ||
          task.objectTypeId == 468 ||
          task.objectTypeId == 479) &&
          transferOptions.canFinishTask &&
          canTransfer
      "
    >
      <b-icon icon="download" class="pd-t-5"></b-icon>
      <template v-if="task.objectTypeId == 465"
        >Бүртгэлтэй эмд бүртгэх</template
      >
      <template v-else-if="task.objectTypeId == 467">Лиценз олгох</template>
      <template v-else-if="task.objectTypeId == 468"
        >Тусгай зөвшөөрөл олгох</template
      >
      <template v-else-if="task.objectTypeId == 479"
        >Дээж импортлох лиценз олгох</template
      >
    </button>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";

export default {
  props: {
    taskId: {
      type: Number,
      default: () => 0
    },
    task: {
      type: Object,
      default: () => {}
    },
    transferOptions: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentColumn: {
        settingFlag: 0,
        isPointUserids: []
      },
      canTransfer: false,
      canFinish: false,
      canOpen: false,
      msg: "Ажиллаж буй хүн шилжүүлэх боломжтой."
    };
  },
  mounted() {
    //console.log(this.task.im, this.task.column);
    if (
      this.task.im != null &&
      this.task.im.pinIs &&
      this.task.column != null
    ) {
      this.canTransfer = true;
    }

    if (
      this.task.objectTypeId == 115 &&
      this.task.im != null &&
      this.task.im.pinIs &&
      !this.task.isCompleted &&
      (this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249)
    ) {
      this.canFinish = true;
    } else if (
      this.task.objectTypeId == 115 &&
      this.task.im != null &&
      this.task.im.pinIs &&
      this.task.isCompleted &&
      (this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249)
    ) {
      this.canOpen = true;
    }

    if (this.task.column != null) {
      let cc = this.transferOptions.taskColumns.filter(
        x => x.id == this.task.column.id
      );
      if (cc.length > 0) {
        this.currentColumn = cc[0];
        if (
          this.currentColumn.settingFlag == 6 ||
          this.currentColumn.settingFlag == 56
        ) {
          this.canTransfer = hasOneOf(this.currentColumn.isPointUserids, [
            this.task.im.userId
          ]);
          if (!this.canTransfer) {
            this.msg = "Зөвхөн хянагч эрхтэй хүн шилжүүлэх боломжтой";
          }
        }
      }
    }
  },
  methods: {}
};
</script>
